import React from 'react';

import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';

const PartnerItem = ({ hit }: { hit: any }) => {
  const { t } = useTranslation();
  const logoUrl = hit.field_logo_url?.[0] ?? null;

  return (
    <div className="ParagraphHighlightedPartners__item">
      {logoUrl && <img src={logoUrl} alt={hit.title?.[0]} />}
      <CoreLink
        ariaLabel={t('searchkit.ariaLabel', { name: hit.title?.[0] })}
        href={hit.url[0]}
      />
    </div>
  );
};

export default PartnerItem;
